import { KuxFavorite, LCBatchesPresentationOrderEnum } from '@kaltura-ott/tvpil';

import type { Linear } from '../stores/entities/Linear';

const favoritesAsc = (a: Linear, b: Linear) => {
  if (!a.favoriteInstance && b.favoriteInstance) {
    return 1;
  }

  if (a.favoriteInstance && !b.favoriteInstance) {
    return -1;
  }

  if (!a.favoriteInstance && !b.favoriteInstance) {
    return 0;
  }

  return (a.favoriteInstance as KuxFavorite).createDate - (b.favoriteInstance as KuxFavorite).createDate;
};

export const sortByOrderBatches = (
  assets: Linear[],
  orderBatches: LCBatchesPresentationOrderEnum[] = [LCBatchesPresentationOrderEnum.lcn],
): Linear[] => {
  const compareFnMap: {
    [key in LCBatchesPresentationOrderEnum]: (a: Linear, b: Linear) => number;
  } = {
    [LCBatchesPresentationOrderEnum.lcn]: (a, b) => a.channelNumber - b.channelNumber,
    [LCBatchesPresentationOrderEnum.fav]: favoritesAsc,
    [LCBatchesPresentationOrderEnum.top_x]: (a, b) => b.watchedCount - a.watchedCount,
  };

  const sorting = assets.sort((a, b) => {
    for (const batch of orderBatches) {
      const compareFn = compareFnMap[batch];
      if (typeof compareFn === 'function') {
        const compareResult = compareFn(a, b);
        if (compareResult !== 0) {
          return compareResult;
        }
      }
    }
    return 0;
  });
  return sorting;
};
